export interface Ticker {
  readonly subscribe: (onChange: () => void) => () => void;
  readonly getSnapshot: () => number;
}

export const createTicker = (periodMs: number): Ticker => {
  const floorNow = (): number => Math.floor(Date.now() / periodMs) * periodMs;
  let snapshot = floorNow();
  let timer: ReturnType<typeof setTimeout> | null = null;
  const listeners = new Set<() => void>();

  const refresh = (): boolean => {
    const next = floorNow();
    if (next === snapshot) return false;
    snapshot = next;
    return true;
  };
  const notify = (): void => {
    if (refresh()) listeners.forEach((listener) => listener());
  };
  const arm = (): void => {
    timer = setTimeout(() => {
      notify();
      arm();
    }, periodMs - (Date.now() % periodMs));
  };

  return {
    subscribe: (onChange) => {
      listeners.add(onChange);
      if (timer === null) {
        notify();
        arm();
      }
      return () => {
        listeners.delete(onChange);
        if (listeners.size === 0 && timer !== null) {
          clearTimeout(timer);
          timer = null;
        }
      };
    },
    getSnapshot: () => {
      if (timer === null) refresh();
      return snapshot;
    },
  };
};
